module.exports = __webpack_public_path__ + "img/spiral-shell.182f9432.png";